





import { Component, Vue, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component
export default class Payment extends Vue {
  @Action("reset", { namespace: "cart" })
  reset: Function;

  @Prop({ required: true })
  public payrexxUrl!: string;

  handlePayement(e: MessageEvent) {
    try {
      const data = JSON.parse(e.data);
      if (data && data.payrexx && data.payrexx.transaction) {
        this.reset().then(() => {
          this.$router.push({
            name: "Thanks",
          });
        });
      }
    } catch (e) {
      return;
    }
  }

  mounted() {
    window.addEventListener("message", this.handlePayement, false);
  }

  beforeDestroy() {
    window.removeEventListener("message", this.handlePayement, false);
  }
}
